$(function() {
  var timezone = TimeUtils.getTzNameByLocation(Config.location, Config.defaultTimezone);
  jQuery.cookie('Timezone', timezone, {
    'useLocalStorage': false,
    'expires': new Date(2100,1,1,1,1,1),
//    'domain': '.' + document.domain,
    'path': '/'
  });
});

// $(function () {
//   document.querySelector('#navbarSideCollapse').addEventListener('click', function () {
//     document.querySelector('#modelsCategories').classList.toggle('open');
//   })
// });

$(function() {
  jQuery(".js-change-language").on("click", function() {
    var uri = new URI();
    uri.removeSearch("language").addSearch("language", $(this).attr("data-language"));
    document.location.href = uri.toString();
    return false;
  });
});

$(function() {
  $("a")
  .filter(function() {return StringUtils.NVL($(this).attr("href"), "").indexOf(Config.performer+"/broadcast") != -1;})
  .each(function() {
    var $t = $(this);
    $t.attr("target", "_blank");
  });
});

$(function() {
  $("a[href=#]").each(function() {
    this.href = Config.exec;
  });
});

$(function() {
  // jQuery("#flogin-menu a.flogin").each(function () {
  //   var el = $(this);
  //   el.qtip({
  //     "style": 'flogin',
  //     "content": jQuery("#" + el.attr("data-qtip2-content")), // Set the tooltip content to the current corner
  //     "position": {
  //       "my": 'bottom center',
  //       "at": 'top center',
  //       "adjust": {
  //         "y": -10
  //       }
  //     },
  //     "show": {
  //       "event": "click",
  //       "solo": true
  //     },
  //     "hide": {
  //       "event": 'unfocus'
  //     }
  //   });
  // }).click(function () {
  //   return false
  // });
var popoverTriggerList = [].slice.call(document.querySelectorAll('#flogin-menu a.flogin'));
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl, {
    html: true,
    content: jQuery("#" + $(popoverTriggerEl).attr("data-qtip2-content")).html(),
    placement: "top"
  });
});

  $("body").on("click", ".js-fav", function() {
    var el = $(this);
    if ($("body").hasClass("role-guest")) {
      redirect(Config.exec+'/login', {'login_redirect_url': document.location.href}, 'post');
      return false;
    }
    if (el.hasClass("isFavorite")) {
      $.getJSON(Config.exec+"/models/removeFavorite/"+el.data("performer-id")+"/"+el.data("foreign-site-id"), {"JsHttpRequest": (new Date()).getTime()});
      el.removeClass("isFavorite");
    } else {
      $.getJSON(Config.exec+"/models/addFavorite/"+el.data("performer-id")+"/"+el.data("foreign-site-id"), {"JsHttpRequest": (new Date()).getTime()});
      el.addClass("isFavorite");
    }
    var isFavorite = el.hasClass("isFavorite"),
        text = StringUtils.NVL(el.attr(isFavorite ? "data-text-remove" : "data-text-add"), ""),
        title = StringUtils.NVL(el.attr(isFavorite ? "data-title-remove" : "data-title-add"), "");

    if (text.length > 0) el.text(text);
    if (title.length > 0) el.attr("title", title);
    return false;
  });

});

$(function() {
  jQuery(".js-change-theme").on("click", function() {
    var uri = new URI();
    uri.removeSearch("theme").addSearch("theme", $(this).attr("data-theme"));
    document.location.href = uri.toString();
    return false;
  });
});

$(function() {
  $(".js-search-submit").click(function() {
    $(this).parents('form')[0].submit();
  });
  $(".js-toggle-search_panel").on("click", function() {
    if (!mqlMobile.matches) {
    $(".search_panel").slideToggle();
    return false;
    }
  });
});

CustomerPerson.getPerformerPaidContent = function (videoId, isPurchasedVideo, videoPrice, container, width, height, performerId, availableDiscount) {
  var link = $(container);
  //var link = container;
  if (link.hasClass("paid") || isPurchasedVideo || videoPrice <= 0) {
    showMaximized(container,width,height);
    return false;
  }

  var text = I18n.t("Do you want to purchase this premium video for {1} credits?", [""+videoPrice]);
  if(availableDiscount < 1) {
      text += '<br/>' + (
          availableDiscount > 0 ?
            I18n.t("You can buy subscription to watch any videos of this model with {1}% discount.", [100*(1-availableDiscount)])
            : I18n.t("You can buy subscription to watch any videos of this model for free.")
        )+ '<br/><a href="' + Config.exec + '/subscription?performer_id=' + performerId + '">' + I18n.t("Buy a subscription for the model") + '</a>';
  }
  swal({
    "title": I18n.t("Buy video"),
    "html" : text
    //,"input": "textarea"
    //,"inputPlaceholder": I18n.t("Type your message here")
    ,"showCancelButton": true
    ,"confirmButtonText": I18n.t("Buy")
    ,"cancelButtonText": I18n.t("Cancel")
    ,background:""
    //,"inputValidator": function(value) {
    //  return !value && I18n.t("You need to write something!")
    //}
  }).then(function(result) {
    if (!result.value) return;
    $.ajax({
      "url": Config.exec+"/plugins/videostore/postback.jsp",
      "type": "POST",
      "cache": false,
      "data": {"command":"buy-video","picture_id":videoId,"price": videoPrice, "performer_id": performerId},
      "dataType": "json",
      "success": function(obj) {
        //console.dir(obj);
        if(obj.res) {
          if (typeof obj.content_url != 'undefined') {
            link.attr("href",obj.content_url);
          }
          showMaximized(container,width,height);
          link.addClass("paid");
          //$("#picture-link-id-"+videoId+" .price").html("<span class=\"note\">Purchased</span>");
          $("#picture-id-"+videoId+" .pay-info").html("<span class=\"note\">Purchased</span>");
          $("#picture-id-"+videoId+" .btn-warning").removeClass("btn-warning").addClass("btn-success");
        }
        else if (typeof obj.msg != "undefined") {
          if (typeof(obj.url) != "undefined" ) {
            swal({"type": 'error', "confirmButtonText":(obj.btnText ? obj.btnText : I18n.t("Ok")), "title": obj.msg,"showCancelButton": true,background:""}).then(function (result) {
              if (result.value) document.location.href=obj.url;
            });

            //if ( confirm(obj.msg) ) {
            //  document.location.href = obj.url;
            //  }
            return ( false );
            }
          else {
            swal({"type": 'error', "title": obj.msg,background:""});
            }
          }
        else if (typeof(obj.url) != "undefined") {
          document.location.href = obj.url
        }
      },
      "error": function() {
      }
    });
    //
  });
  return;
  };

const VideoStore = function (){}

VideoStore.showGalleryPreview = function (item) {
  const $item = $(item)
  const video = $item.find('video')
  if (video[0].src === '') {
    video[0].src = video[0].dataset['src']
  }
  video[0].play();
  $item.addClass('played')
}
VideoStore.hideGalleryPreview = function (item) {
  const $item = $(item)
  $item.find('video')[0].pause();
  $item.removeClass('played')
}


$(window).ready(function() {
  Array.from(document.getElementsByClassName("o-hidden")).forEach(function (element) {
    element.addEventListener('scroll',
      function (event) {
        if (event.target.scrollLeft === 0) {
          $(element).addClass('grad-right');
          $(element).removeClass('grad-left');
          $(element).removeClass('grad-both');
        } else if ((event.target.scrollLeft > 0) && (event.target.scrollLeft !== element.scrollWidth - element.clientWidth)) {
          $(element).removeClass('grad-left')
          $(element).removeClass('grad-right');
          $(element).addClass('grad-both');
        } else if (event.target.scrollLeft === element.scrollWidth - element.clientWidth) {
          $(element).removeClass('grad-right')
          $(element).removeClass('grad-both');
          $(element).addClass('grad-left');
        }
      })
  })
})

$(document).on('click','#qtip-overlay',function(){
  $('#ui-datepicker-div').hide()
});

$(function() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .register('../../../sw.js', {scope: '../../../'} )
        .then(function(reg){
        }).catch(function(err) {
      console.log(err)
    });
  }
});
